module.exports = __webpack_public_path__ + "img/RIGID PGG TRUCK_LHD.b9fcf4c2.jpg";